<template>

  <span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">
          <vs-tab v-if="$canAny(['view-supplier','create-edit-supplier'])" icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'RM Suppliers' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <manage-suppliers/>
            </div>
          </vs-tab>
           <vs-tab v-if="$canAny(['view-sundry-suppliers','create-edit-sundry-suppliers'])" icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Sundry Suppliers' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <sundry-suppliers-list/>
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny(['view-courier-suppliers','create-edit-courier-suppliers'])" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Courier Suppliers' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <couriers-list/>
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny(['view-other-suppliers','create-edit-other-suppliers'])" icon-pack="feather" icon="icon-octagon" :label="!isSmallerScreen ? 'Other Suppliers' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <other-suppliers-list/>
            </div>
          </vs-tab>

<!--          <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Other supplier categories' : ''">-->
<!--            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">-->
<!--              <other-supplier-category-manage/>-->
<!--            </div>-->
<!--          </vs-tab>-->
        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>

  import ManageSuppliers from "./ManageSuppliers";
  import SundrySuppliersList from "./sundry-suppliers/SundrySuppliersList";
  import CouriersList from "./couriers/CouriersList";
  import OtherSuppliersList from "@/views/pages/supplier-manage/other-suppliers/OtherSuppliersList";
  import OtherSupplierCategoryManage
    from "@/views/pages/supplier-manage/other-supplier-category/OtherSupplierCategoryManage";

  export default {
    name: 'ManageSuppliersTabView',
    data() {
      return {
        active_step: this.$route.query.step ? Number(this.$route.query.step) - 1 : '0'
      }
    },
    components: {
      ManageSuppliers,
      SundrySuppliersList,
      CouriersList,
      OtherSuppliersList,
      OtherSupplierCategoryManage,
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
